import { ScrollDispatchModule, ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import interactionPlugin from '@fullcalendar/interaction'; // a plugin
import { NgSelectModule } from "@ng-select/ng-select";
import { NgMonthPickerModule } from "ng-month-picker";
import { TooltipModule } from "../modules/tooltip/tooltip.module";
import { CustomSearchPipe } from "../shared/customSearch-pipe/customSearch-pipe";
import { CustomFieldsFilterModule } from '../shared/customFieldsFilter-pipe/customFieldFilter.module';
import { CustomSearchPipeModule } from "../shared/customSearch-pipe/customSearch.module";
import { IntouchWidgetModule } from "../shared/intouch-widget/intouch-widget.module";

import { LinkModule } from "../shared/link/link.module";
import { OrderByModule } from "../shared/sorting-pipe/orderBy-module";
import { AttendnaceComponent } from "./attendance.component";
import { AttendanceRoutingModule } from "./attendance.module.routing";
import { EditTeamAttendnaceComponent } from "./edit-team-attendnace/edit-team-attendnace.component";
import { EmployeeCountByTeamComponent } from "./employees-count-by-team/employees-count-by-team.component";
import { LeaveApplicationComponent } from "./leave-application/leave-application.component";
import { LeaveSummaryComponent } from "./leave-summary/leave-summary.component";
import { MyAttendnaceComponent } from "./my-attendance/my-attendance.component";
import { TeamAttendnaceComponent } from "./team-attendance/team-attendance.component";
import { TeamLeaveApprovalComponent } from "./team-leave-approval/team-leave-approval.component";
import {AttendanceParentComponent} from "./attendance-parent.component";

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
    dayGridPlugin,
    interactionPlugin
  ]);

@NgModule({
    declarations: [
        AttendanceParentComponent,
        AttendnaceComponent,
        MyAttendnaceComponent,
        TeamAttendnaceComponent,
        TeamLeaveApprovalComponent,
        LeaveSummaryComponent,
        EmployeeCountByTeamComponent,
        LeaveApplicationComponent,
        EditTeamAttendnaceComponent,
       
    ],
    imports:[
        LinkModule,
        AttendanceRoutingModule,
        CommonModule,
        FormsModule,
        FullCalendarModule,
        ScrollingModule, 
        ScrollDispatchModule,
        NgMonthPickerModule,
        NgSelectModule,
        IntouchWidgetModule,
        TooltipModule,
        OrderByModule,
        CustomSearchPipeModule,
        CustomFieldsFilterModule
        
    ],
    exports:[

    ],
    providers:[
        DatePipe
    ]
})

export class AttendanceModule{
    constructor(){

    }
}